import React from 'react';
import { StarIcon, FileTextIcon, ZapIcon, BookOpenIcon } from 'lucide-react';
import { BuyButton, scrollToBuy } from './BuyButton';
export function Hero() {
  return <section className="w-full bg-gradient-to-b from-green-50 via-white to-sky-50 pt-8 pb-10 px-4" data-id="element-138">
      <div className="max-w-5xl mx-auto text-center" data-id="element-139">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight text-slate-900" data-id="element-140">
          Se studi veterinaria <span className="text-green-700" data-id="element-141">e tanto</span>,
          ma senti di <span className="text-green-700" data-id="element-142">rendere poco</span>...
          questo è per te.
        </h1>

        <div className="mt-3 flex justify-center" data-id="element-143">
          <button onClick={scrollToBuy} className="block group" data-id="element-144">
            <img src="https://cdn.magicpatterns.com/uploads/8Kcsgkm9tPz5xNUu8z7E9f/Gemini_Generated_Image_ouguixouguixougu-removebg-preview.png" alt="Carrera Veterinaria 360 — la guida pratica definitiva per studenti" className="w-[88%] max-w-md mx-auto drop-shadow-2xl group-hover:scale-[1.02] transition-transform duration-300" data-id="element-145" />
          </button>
        </div>

        <h2 className="mt-6 sm:mt-8 text-lg sm:text-xl md:text-2xl font-semibold text-slate-700 max-w-3xl mx-auto leading-snug" data-id="element-146">
          6 moduli + 6 bonus con tutto ciò di cui uno studente di veterinaria ha
          bisogno per passare{' '}
          <span className="text-green-700 font-bold" data-id="element-147">
            dall'aula alla clinica
          </span>{' '}
          con criterio e sicurezza.
        </h2>

        <div className="mt-5 flex flex-wrap justify-center items-center gap-2 sm:gap-3 text-sm sm:text-base font-semibold text-slate-700" data-id="element-148">
          <span className="inline-flex items-center gap-2 bg-white border border-green-200 px-3 py-1.5 rounded-full shadow-sm" data-id="element-149">
            <FileTextIcon className="w-4 h-4 text-green-600" data-id="element-150" /> 100% PDF
          </span>
          <span className="inline-flex items-center gap-2 bg-white border border-green-200 px-3 py-1.5 rounded-full shadow-sm" data-id="element-151">
            <ZapIcon className="w-4 h-4 text-green-600" data-id="element-152" /> Accesso Immediato
          </span>
          <span className="inline-flex items-center gap-2 bg-white border border-green-200 px-3 py-1.5 rounded-full shadow-sm" data-id="element-153">
            <BookOpenIcon className="w-4 h-4 text-green-600" data-id="element-154" /> 6 moduli + 6
            bonus
          </span>
        </div>

        <div className="mt-4 flex justify-center items-center gap-2" data-id="element-155">
          <div className="flex" data-id="element-156">
            {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-5 h-5 text-yellow-500 fill-yellow-500" data-id="element-157" />)}
          </div>
          <span className="font-bold text-slate-800" data-id="element-158">4.9/5.0</span>
          <span className="text-slate-500 text-sm" data-id="element-159">(+1.200 studenti)</span>
        </div>

        <div className="mt-6" data-id="element-160">
          <BuyButton label="VOGLIO ACCEDERE ORA" pulse data-id="element-161" />
        </div>
      </div>
    </section>;
}